import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { ReduxState, useAppDispatch } from '../../store';
import { useUnarchiveEntityList } from '../ProjectAdministration/EntityListAdministration/hooks/useUnarchiveEntityList';
import { AvailableModals, closeModal } from './modalSlice';

const EntityListUnarchiveConfirmationModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const data = useSelector(
    (state: ReduxState) =>
      state.modal.modalData[AvailableModals.ENTITY_LIST_UNARCHIVE_CONFIRMATION],
  );
  const projectShortName = useSelector(
    (state: ReduxState) => state.userReducer.selectedProjectShortName,
  );
  const { unarchive, isLoading } = useUnarchiveEntityList();
  useEffect(() => {
    if (data && data.projectShortName !== projectShortName) dispatch(closeModal());
  }, [data, dispatch, projectShortName]);

  if (!data) return null;

  return (
    <Modal
      open={true}
      title="Unarchive this list?"
      okText="Unarchive"
      cancelText="Cancel"
      confirmLoading={isLoading}
      cancelButtonProps={{ disabled: isLoading }}
      closable={!isLoading}
      keyboard={!isLoading}
      maskClosable={false}
      onCancel={() => {
        if (!isLoading) dispatch(closeModal());
      }}
      onOk={() => {
        void unarchive(data, true).then(isUnarchived => {
          if (isUnarchived) dispatch(closeModal());
        });
      }}
    >
      <p>
        We need to run computations before you can use this list. This may take a few minutes. The
        application will be unavailable to everyone in this project while they run.
      </p>
    </Modal>
  );
};

export default EntityListUnarchiveConfirmationModal;
